export const breadcrumbLiquidacionDeuda = [
    { label: 'Inicio', url: '/' },
    { label: 'Reportes', url: `/reportes` },
    { label: 'Liquidación de Deuda', active: true },
]